// extracted by mini-css-extract-plugin
export default {"container":"dqAdqX","isPinned":"o467pO","postTitle":"ZCmPZl","contentExcerpt":"Avmupx","coverMedia":"UNzKyD"};